(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.bottom) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal){
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function initOffersCarousel(section) {
    if (!section || section.dataset.offersInitialized === 'true') {
      return;
    }
    section.dataset.offersInitialized = 'true';
    const track = section.querySelector('.offers-track');
    const viewport = section.querySelector('.offers-viewport');
    const slides = Array.from(section.querySelectorAll('.offers-slide'));

    const prevButton = section.querySelector('.offers-arrow--prev');
    const nextButton = section.querySelector('.offers-arrow--next');

    const currentElement = section.querySelector('.offers-counter-current');
    const totalElement = section.querySelector('.offers-counter-total');
    const controls = section.querySelector('.offers-controls');

    /*
      Use IDs as a fallback because the buttons use Dawn's
      existing slider button classes.
    */
    const prev = section.querySelector('[id^="OffersPrev-"]');
    const next = section.querySelector('[id^="OffersNext-"]');

    if (!track || !viewport || !slides.length) {
      return;
    }
    let currentIndex = 0;
    let animationFrameId = null;
    let animationToken = 0;
    let isAnimating = false;
    let visibleCards = 4;
    let cardWidth = 0;
    let gap = 12;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;


    /* DETERMINE RESPONSIVE SETTINGS */
    function getSettings() {
      const width = window.innerWidth;
      if (width >= 990) {
        return {
          visible: 4,
          gap: 12
        };
      } else if (width >= 500) {
        return {
          visible: 2,
          gap: 16
        };
      } else {
        return {
          visible: 1,
          gap: 16
        };
      }
    }
    /* CALCULATE CARD WIDTH */
    function calculateCardWidth() {
      const settings = getSettings();
      visibleCards = settings.visible;
      gap = settings.gap;
      const viewportWidth = viewport.clientWidth;
      cardWidth =
        (
          viewportWidth -
          (gap * (visibleCards - 1))
        ) / visibleCards;
        
      slides.forEach(function (slide) {
        slide.style.width = cardWidth + 'px';
        slide.style.minWidth = cardWidth + 'px';
        slide.style.maxWidth = cardWidth + 'px';
        slide.style.flexBasis = cardWidth + 'px';
      });
    }

    function getMaxIndex() {
      return Math.max(
        0,
        slides.length - visibleCards
      );
    }

    /* UPDATE COUNTER */
    function updateCounter() {
      const totalPositions = getMaxIndex() + 1;
      if (currentElement) {
        currentElement.textContent = currentIndex + 1;
      }

      if (totalElement) {
        totalElement.textContent = totalPositions;
      }

      if (prev) {
        prev.disabled = currentIndex <= 0;
        prev.setAttribute(
          'aria-disabled',
          currentIndex <= 0 ? 'true' : 'false'
        );
      }

      if (next) {
        next.disabled = currentIndex >= getMaxIndex();
        next.setAttribute(
          'aria-disabled',
          currentIndex >= getMaxIndex() ? 'true' : 'false'
        );
      }

      if (controls) {
        controls.style.display =
          totalPositions <= 1 ? 'none' : '';
      }
    }

    /* MOVE CAROUSEL */
    function goTo(index, animate) {
      const maxIndex = getMaxIndex();
      const newIndex = Math.max(0, Math.min(index, maxIndex));
      // Cancel any animation already in progress.
      animationToken++;
      const token = animationToken;
      if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }

      // Read the track's actual rendered position.
      const matrix = new DOMMatrixReadOnly(
        getComputedStyle(track).transform
      );
      const startDistance = -matrix.m41;

      // Use the actual slide position to avoid accumulated spacing errors.
      const endDistance =
        slides[newIndex].offsetLeft - slides[0].offsetLeft;
      currentIndex = newIndex;

      const items = track.querySelectorAll('.offers-slide');
      items.forEach(function (item) {
        item.classList.remove('offer-is-settled');
        item.classList.add('offer-is-moving');
      });

      updateCounter();

      if (!animate || Math.abs(endDistance - startDistance) < 0.5) {
        track.style.transform =
          `translate3d(${-endDistance}px, 0, 0)`;
        isAnimating = false;
        items.forEach(function (item) {
          item.classList.remove('offer-is-moving');
          item.classList.add('offer-is-settled');
        });
        return;
      }

      const duration = 400;
      const distance = endDistance - startDistance;
      const startTime = performance.now();

      isAnimating = true;
      function animateFrame(now) {
        if (token !== animationToken) return;
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        const position = startDistance + distance * eased;

        track.style.transform =
          `translate3d(${-position}px, 0, 0)`;

        if (progress < 1) {
          animationFrameId = requestAnimationFrame(animateFrame);
          return;
        }

        track.style.transform =
          `translate3d(${-endDistance}px, 0, 0)`;

        animationFrameId = null;
        isAnimating = false;

        items.forEach(function (item) {
          item.classList.remove('offer-is-moving');
          item.classList.add('offer-is-settled');
        });

        setTimeout(function () {
          if (token !== animationToken) return;

          items.forEach(function (item) {
            item.classList.remove('offer-is-settled');
          });
        }, 400);
      }

      animationFrameId = requestAnimationFrame(animateFrame);
    }

    function nextSlide() {
      if (currentIndex < getMaxIndex()) {
        goTo(currentIndex + 1, true);
      }
    }

    function previousSlide() {
      if (currentIndex > 0) {
        goTo(currentIndex - 1, true);
      }
    }

    if (next) {
      next.addEventListener('click', function () {
        nextSlide();
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        previousSlide();
      });
    }

    viewport.addEventListener(
      'pointerdown',
      function (event) {
        if (
          event.pointerType !== 'touch' &&
          event.pointerType !== 'pen'
        ) {
          return;
        }

        startX = event.clientX;
        currentX = event.clientX;
        isDragging = true;

        viewport.setPointerCapture(event.pointerId);

      }
    );

    viewport.addEventListener(
      'pointermove',
      function (event) {

        if (!isDragging) {
          return;
        }
        currentX = event.clientX;
      }
    );

    viewport.addEventListener(
      'pointerup',
      function (event) {
        if (!isDragging) {
          return;
        }
        isDragging = false;
        const distance = currentX - startX;

        if (Math.abs(distance) > 50) {
          if (distance < 0) {
            nextSlide();
          } else {
            previousSlide();
          }
        }
      }
    );

    viewport.addEventListener(
      'pointercancel',
      function () {
        isDragging = false;
      }
    );

    viewport.setAttribute('tabindex', '0');

    viewport.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          nextSlide();
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          previousSlide();
        }
      }
    );

    let resizeTimer;
    function handleResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const oldVisibleCards = visibleCards;
        calculateCardWidth();

        if (oldVisibleCards !== visibleCards) {
          currentIndex = Math.min(
            currentIndex,
            getMaxIndex()
          );
        } else {
          currentIndex = Math.min(
            currentIndex,
            getMaxIndex()
          );
        }
        goTo(currentIndex, false);
      }, 100);
    }
    window.addEventListener(
      'resize',
      handleResize
    );

    calculateCardWidth();

    goTo(0, false);
  }

    function initAllOffers() {
        document
        .querySelectorAll(
        '.offers-carousel'
        )
        .forEach(function (section) {
        initOffersCarousel(section);
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener(
        'DOMContentLoaded',
        initAllOffers
        );
    } else {
        initAllOffers();
    }
    document.addEventListener(
        'shopify:section:load',
        function (event) {
            const section =
                event.target.querySelector(
                '.offers-carousel'
                );
            if (section) {
                initOffersCarousel(section);
            }
        }
    );
})();

  } catch(e) { console.error(e); }
})();
})();
